// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1Xf4O","footer":"ModalCreateQualiphyProcedure_footer__1BzFY","additionData":"ModalCreateQualiphyProcedure_additionData__2Y-uo"};